/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connection_Settings_LabelInputs */



/**
* | output |
* | --- |
* | "Synced content" |
*
* @param {Spaces_Connection_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connection_settings_label = /** @type {((inputs?: Spaces_Connection_Settings_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connection_Settings_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierte Inhalte")
	return /** @type {LocalizedString} */ ("Synced content")
});